import _ from "lodash";
import { FetchState } from "@/shared/types";
import { defineStore } from "pinia";
import * as storeHelper from "@/shared/storeHelper";
import { useNotifierStore } from "@/shared/store/notifier";
import { CardCustomizationBulkImportFileUploadRequest, CardCustomizationBulkImportFileState } from "@/admin/types";
import {
  getCardCustomizationBulkImportFiles as serviceGetBulkImportFiles,
  uploadCardCustomizationBulkImportFile as serviceUploadBulkImportFile,
  getCardCustomizationBulkImportResultsFileUrl
} from "@/shared/api/cardService";

export const initialState: CardCustomizationBulkImportFileState = {
  files: [],
  fetchState: FetchState.Uninitialized
};

export const useCardCustomizationBulkImportStore = defineStore("cardCustomizationBulkImport", {
  state: (): CardCustomizationBulkImportFileState => (_.cloneDeep(initialState)),
  getters: {
    isLoaded: state => state.fetchState === FetchState.Loaded,
    isLoading: state => state.fetchState === FetchState.Loading,
    isFailed: state => state.fetchState === FetchState.Failed
  },
  actions: {
    loadBulkImportFiles () {
      this.fetchState = FetchState.Loading;

      serviceGetBulkImportFiles()
        .then(response => {
          this.files = response.data.files;
          this.fetchState = FetchState.Loaded;
        })
        .catch(error => {
          this.fetchState = FetchState.Failed;
          this.files = [];
          return storeHelper.handleError({ error, rethrow: false });
        });
    },
    uploadBulkImportFile (request: CardCustomizationBulkImportFileUploadRequest) {
      return serviceUploadBulkImportFile(request.file)
        .then(() => {
          const notifier = useNotifierStore();
          notifier.setSuccess("Your file is processing, check the file status below.");
        })
        .catch(error => {
          return storeHelper.handleError({ error, rethrow: true });
        });
    },
    downloadResultsFile (fileId: number) {
      getCardCustomizationBulkImportResultsFileUrl(fileId)
        .then(response => {
          window.open(response.data.url, "_blank");
        })
        .catch(error => {
          return storeHelper.handleError({ error, rethrow: false });
        });
    }
  }
});
